import axios from './auth'

const PMS_BASE_URL = `${process.env.VUE_APP_API_BASE_URL}/sr/pms`
const user_id = localStorage.getItem('profile')
  ? JSON.parse(localStorage.getItem('profile'))?.id
  : null

function axiosSr(config) {
  return axios({
    ...config,
    params: {
      ...config.params,
      user_id,
    },
  })
}

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  // UPLOAD FILE PMS

  async uploadFilePms({ commit }, payload = {}) {
    const url = `${PMS_BASE_URL}/upload-file`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload,
    }

    try {
      const response = await axios(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data,
      }
    }
  },

  async uploadFilePmsMultiple({ commit }, payload = {}) {
    const url = `${PMS_BASE_URL}/upload-multiple-files`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload,
    }

    try {
      const response = await axios(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data,
      }
    }
  },

  async deleteMaintenanceAttachment({ commit }, attachmentId) {
    const url = `${PMS_BASE_URL}/maintenance-attachments/${attachmentId}`

    const method = 'delete'
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
    const config = {
      url,
      method,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response?.data,
      }
    }
  },

  // END UPLOAD FILE PMS

  // MASTER CATEGORY EQUIPMENT
  async getEquipmentCategory({ commit }, params = {}) {
    const url = `${PMS_BASE_URL}/equipment-category`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async createEquipmentCategory({ commit }, payload) {
    const url = `${PMS_BASE_URL}/equipment-category`

    const method = 'post'
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
    const config = {
      url,
      method,
      data: payload,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async updateEquipmentCategory({ commit }, payload = {}) {
    const url = `${PMS_BASE_URL}/equipment-category/${payload.id}`

    const method = 'put'
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async deleteEquipmentCategory({ commit }, id) {
    const url = `${PMS_BASE_URL}/equipment-category/${id}`

    const method = 'delete'
    const headers = {}
    const config = {
      url,
      method,
      headers,
    }

    try {
      await axiosSr(config)
      return { status: 'success' }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async importEquipmentCategory({ commit }, body) {
    const url = `${PMS_BASE_URL}/equipment-category/import`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: body,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  // END MASTER CATEGORY EQUIPMENT

  // MASTER EQUIPMENT
  async getEquipment({ commit }, params = {}) {
    const url = `${PMS_BASE_URL}/equipments`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async exportEquipment({ commit }, payload) {
    const url = `${PMS_BASE_URL}/equipments`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      responseType: 'blob',
      params: { exportFormat: 'xlsx' },
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async createEquipment({ commit }, payload) {
    const url = `${PMS_BASE_URL}/equipments`

    const method = 'post'
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
    const config = {
      url,
      method,
      data: payload,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async updateEquipment({ commit }, payload = {}) {
    const url = `${PMS_BASE_URL}/equipments/${payload.id}`

    const method = 'put'
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async deleteEquipment({ commit }, id) {
    const url = `${PMS_BASE_URL}/equipments/${id}`

    const method = 'delete'
    const headers = {}
    const config = {
      url,
      method,
      headers,
    }

    try {
      await axiosSr(config)
      return { status: 'success' }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async exportTemplateEquipment({ commit }, payload) {
    const url = `${PMS_BASE_URL}/equipments/import-template`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      responseType: 'blob',
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
        params: { exportFormat: 'xlsx' },
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async exportTemplateEquipmentCategory({ commit }, payload) {
    const url = `${PMS_BASE_URL}/equipment-category/import-template`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      responseType: 'blob',
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
        params: { exportFormat: 'xlsx' },
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async importEquipment({ commit }, body) {
    const url = `${PMS_BASE_URL}/equipments/import`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: body,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  // END MASTER  EQUIPMENT

  // IMPORT EXPORT ASSIGN JOB LIBRARY FLEET

  async exportTemplateAssignJobToFleet({ commit }, payload) {
    const url = `${PMS_BASE_URL}/job-libraries/assigns/import-template`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      responseType: 'blob',
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
        params: { exportFormat: 'xlsx' },
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async importAssignJobLibraryToFleet({ commit }, body) {
    const url = `${PMS_BASE_URL}/job-libraries/assigns/import`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: body,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  // END IMPORT EXPORT ASSIGN JOB LIBRARY FLEET

  // JOB LIBRARIES
  async getJobLibrayrCategory({ commit }, params = {}) {
    const url = `${PMS_BASE_URL}/job-library-groups`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async getVehicleForAssignJob({ commit }, params = {}) {
    const url = `${PMS_BASE_URL}/list-vehicle-assigns`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async getJobLibraries({ commit }, params = {}) {
    const url = `${PMS_BASE_URL}/job-libraries`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async assignJobLibraryToVehilcle({ commit }, payload) {
    const url = `${PMS_BASE_URL}/job-libraries/assigns`

    const method = 'post'
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
    const config = {
      url,
      method,
      data: payload,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async createJobLibraries({ commit }, payload) {
    const url = `${PMS_BASE_URL}/job-libraries`

    const method = 'post'
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
    const config = {
      url,
      method,
      data: payload,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async updateJobLibraries({ commit }, payload = {}) {
    const url = `${PMS_BASE_URL}/job-libraries/${payload.id}`

    const method = 'put'
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async deleteJobLibraries({ commit }, id) {
    const url = `${PMS_BASE_URL}/job-libraries/${id}`

    const method = 'delete'
    const headers = {}
    const config = {
      url,
      method,
      headers,
    }

    try {
      await axiosSr(config)
      return { status: 'success' }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async exportTemplateJobLibraries({ commit }, payload) {
    const url = `${PMS_BASE_URL}/job-libraries/import-template`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      responseType: 'blob',
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
        params: { exportFormat: 'xlsx' },
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async importJobLibraries({ commit }, body) {
    const url = `${PMS_BASE_URL}/job-libraries/import`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: body,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  // END JOB LIBRARIES

  // RUNNING HOURS NEW
  async getRunningHoursV3({ commit }, params = {}) {
    const url = `${PMS_BASE_URL}/running-histories`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async createRunningHoursV3({ commit }, payload) {
    const url = `${PMS_BASE_URL}/running-histories`

    const method = 'post'
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
    const config = {
      url,
      method,
      data: payload,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async updateRunningHoursV3({ commit }, payload = {}) {
    const url = `${PMS_BASE_URL}/running-histories/${payload.vehicleId}`

    const method = 'put'
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
    const config = {
      url,
      method,
      headers,
      data: { data: payload.data },
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data.data,
      }
    }
  },

  async deleteRunningHoursV3({ commit }, { id, data }) {
    const url = `${PMS_BASE_URL}/running-histories/${id}`

    const method = 'delete'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data,
    }

    try {
      await axiosSr(config)
      return { status: 'success' }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async exportTemplateRunningHoursV3({ commit }, params) {
    const url = `${PMS_BASE_URL}/running-histories/import-template`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      responseType: 'blob',
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
        params: { exportFormat: 'xlsx' },
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async exportRunningHoursV3({ commit }, params) {
    const url = `${PMS_BASE_URL}/running-histories/export`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      responseType: 'blob',
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
        params: { exportFormat: 'xlsx' },
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async importRunningHoursV3({ commit }, body) {
    const url = `${PMS_BASE_URL}/running-histories/import`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: body,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  // END RUNNING HOURS NEW

  // GOH NEW
  async getGOH({ commit }, params = {}) {
    const url = `${PMS_BASE_URL}/vehicle-running-kickoff-goh`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async createGOH({ commit }, payload) {
    const url = `${PMS_BASE_URL}/vehicle-running-kickoff-goh`

    const method = 'post'
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
    const config = {
      url,
      method,
      data: payload,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async updateGOH({ commit }, payload = {}) {
    const url = `${PMS_BASE_URL}/vehicle-running-kickoff-goh/${payload.id}`

    const method = 'put'
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
    const config = {
      url,
      method,
      headers,
      data: payload,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data.data,
      }
    }
  },

  async deleteGOH({ commit }, { id, data }) {
    const url = `${PMS_BASE_URL}/vehicle-running-kickoff-goh/${id}`

    const method = 'delete'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data,
    }

    try {
      await axiosSr(config)
      return { status: 'success' }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async exportTemplateGOH({ commit }, params) {
    const url = `${PMS_BASE_URL}/kickoff-goh/import-template`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      responseType: 'blob',
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
        params: { exportFormat: 'xlsx' },
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async exportGOH({ commit }, params) {
    const url = `${PMS_BASE_URL}/vehicle-running-kickoff-goh/export`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      responseType: 'blob',
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
        params: { exportFormat: 'xlsx' },
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async importGOH({ commit }, body) {
    const url = `${PMS_BASE_URL}/vehicle-running-kickoff-goh/import`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: body,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  // END GOH NEW

  // ADJUSMENT RUNNING HOURS NEW
  async getAdjustmentRhV3({ commit }, params = {}) {
    const url = `${PMS_BASE_URL}/running-adjustments`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async getVehiclePowerListV3({ commit }, vehicleId) {
    const url = `${PMS_BASE_URL}/vehicle-power-list/${vehicleId}`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: 'error',
        data: e,
      }
    }
  },
  async createAdjustmentRhV3({ commit }, payload) {
    const url = `${PMS_BASE_URL}/running-adjustments/${payload.vehicleId}`

    const method = 'post'
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
    const config = {
      url,
      method,
      data: { ...payload.data, userId: user_id },
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async deleteAdjustmentRhV3({ commit }, id) {
    const url = `${PMS_BASE_URL}/running-adjustments/${id}`

    const method = 'delete'
    const headers = {}
    const config = {
      url,
      method,
      headers,
    }

    try {
      await axiosSr(config)
      return { status: 'success' }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  // END ADJUSMENT RUNNING HOURS NEW

  // MAINTENANCE TRANSACTION

  async getPlanMaintenance({ commit }, params = {}) {
    const url = `${PMS_BASE_URL}/summary`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async getPmsSummaryVehicles({ commit }, params = {}) {
    const url = `${PMS_BASE_URL}/summary/vehicle`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async getPmsSummaryByVehicle({ commit }, params = {}) {
    const url = `${PMS_BASE_URL}/summary/vehicle/${params?.vehicle_id}`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async getPmsOfflineActivities({ commit }, params = {}) {
    const url = `${PMS_BASE_URL}/offline-activities`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async createPmsOfflineActivity({ commit }, payload = {}) {
    const url = `${PMS_BASE_URL}/offline-activities`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async createPmsSettingReminders({ commit }, payload = []) {
    const url = `${PMS_BASE_URL}/setting-reminders`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async getPmsSettingReminders({ commit }) {
    const url = `${PMS_BASE_URL}/setting-reminders`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async getPmsSummaryByJob({ commit }, params = {}) {
    const url = `${PMS_BASE_URL}/summary/job/${params?.pms_vehicle_id}`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async getPmsRunningHours({ commit }, params = {}) {
    const url = `${PMS_BASE_URL}/vehicle-power-list/${params?.vehicle_id}`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async getCommentPms({ commit }, params = {}) {
    const url = `${PMS_BASE_URL}/comment-pms/${params?.maintenance_id}`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async exportPlanMaintenance({ commit }, params) {
    const url = `${PMS_BASE_URL}/summary`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      responseType: 'blob',
      params: { ...params, export: true },
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async exportPmsSummaryByVehicle({ commit }, params) {
    const url = `${PMS_BASE_URL}/summary/vehicle/${params?.vehicle_id}`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      responseType: 'blob',
      params: { ...params, export: true },
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async exportPmsSummaryByJob({ commit }, params) {
    const url = `${PMS_BASE_URL}/summary/job/${params?.pms_vehicle_id}`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      responseType: 'blob',
      params: { ...params, export: true },
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async actionMaintenance({ commit }, payload) {
    const url = `${PMS_BASE_URL}/action-pms/${payload.maintenanceId}`

    const method = 'post'
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
    const config = {
      url,
      method,
      data: payload.body,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async actionMaintenanceMultiple({ commit }, payload) {
    const url = `${PMS_BASE_URL}/action-pms/process/multiple`

    const method = 'post'
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
    const config = {
      url,
      method,
      data: payload,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async exportTemplatePmsProcessMultiple({ commit }, params = {}) {
    const url = `${PMS_BASE_URL}/action-pms/process/multiple/import-template`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
      responseType: 'blob',
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
        params: { exportFormat: 'xlsx' },
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async importPmsProcessMultiple({ commit }, body) {
    const url = `${PMS_BASE_URL}/action-pms/process/multiple/import`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: body,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async createCommentPms({ commit }, payload) {
    const url = `${PMS_BASE_URL}/comment-pms/${payload.maintenanceId}`

    const method = 'post'
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
    const config = {
      url,
      method,
      data: payload.data,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async approvePms({ commit }, payload) {
    const url = `${PMS_BASE_URL}/approval/${payload?.maintenance_id}`

    const method = 'post'
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
    const config = {
      url,
      method,
      data: payload,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async softDeletePms({ commit }, payload = {}) {
    const url = `${PMS_BASE_URL}/delete-pms/${payload.id}`

    const method = 'put'
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
    const config = {
      url,
      method,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async deletejobPms({ commit }, payload = {}) {
    const url = `${PMS_BASE_URL}/pms-vehicle-assigns/${payload.pms_vehicle_id}`

    const method = 'delete'
    const headers = {}
    const config = {
      url,
      method,
      headers,
    }

    try {
      const res = await axiosSr(config)
      return { status: 'success', data: res.data }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async getRhByDate({ commit }, params = {}) {
    const url = `${PMS_BASE_URL}/calculate-total-running-hours`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async getDeleteAuditLogsRh({ commit }, params = {}) {
    const url = `${PMS_BASE_URL}/running-histories/delete-audit-logs`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data?.data
      console.log('data', data)

      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  // END MAINTENANCE TRANSACTION
}
